import { useState, useEffect } from 'react'

import { DEFAULT_DEBOUNCE_TIME } from '../constants/app'

export function useDebounce(value, delay = DEFAULT_DEBOUNCE_TIME) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
